/**
 * Footer: „Created by kapelari.studio" wird getippt, sobald die Zeile in den
 * Viewport kommt (einmalig). GSAP TextPlugin + ScrollTrigger (funktioniert mit
 * dem seitenweiten ScrollSmoother, bei kurzen Seiten direkt nach dem Laden).
 *
 * Markup: footer.php – [data-kkg-credit] mit Spans [data-kkg-credit-type="…"]
 * (aria-hidden, werden geleert und getippt); der volle Text liegt visuell
 * versteckt daneben, ohne JS bleibt alles sichtbar.
 * prefers-reduced-motion: kein Tippen, Text bleibt statisch.
 */
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";

gsap.registerPlugin(ScrollTrigger, TextPlugin);

// Tippgeschwindigkeit: Sekunden pro Zeichen
const SECONDS_PER_CHAR = 0.08;

export function initFooterCredit() {
    const credit = document.querySelector("[data-kkg-credit]");
    const parts = credit ? Array.from(credit.querySelectorAll("[data-kkg-credit-type]")) : [];
    if (!credit || !parts.length || window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        return null;
    }

    // Zeilenhöhe halten, damit die Leiste beim Leeren nicht zusammenfällt
    credit.style.minHeight = credit.getBoundingClientRect().height + "px";
    parts.forEach((part) => { part.textContent = ""; });

    const timeline = gsap.timeline({ paused: true, defaults: { ease: "none" } });
    parts.forEach((part) => {
        const text = part.dataset.kkgCreditType || "";
        timeline.to(part, { text: { value: text, preserveSpaces: true }, duration: text.length * SECONDS_PER_CHAR });
    });

    ScrollTrigger.create({
        trigger: credit,
        start: "top bottom", // sobald die Zeile den unteren Viewport-Rand erreicht
        once: true,
        onEnter: () => timeline.play(),
    });

    return timeline;
}
